module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/related/zh-hans/4-5decfd87bb8ece814f0d18583558568e.jpg";